import React, { useState, useEffect } from 'react';
import { randers3data } from '../../../../../Services/SystemSettings/SystemServices';

function Cashfree() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const key = 'CASHFREE';
        const responseData = await randers3data(key);
        setData(responseData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (key, value) => {
    setData(prevData => {
      const newData = prevData.map(item => {
        if (item.key === key) {
          return { ...item, value };
        }
        return item;
      });
      return newData;
    });
  };

  return (
    <div id="s3div">
      <form className="row g-3">
        <div className="col-12">
          <label htmlFor="appId" className="form-label">App Id</label>
          <input
            type="text"
            className="form-control"
            id="appId"
            name='appId'
            value={data?.find(item => item.key === 'appId')?.value || ''}
            onChange={(e) => handleInputChange('appId', e.target.value)}
          />
          <div className={`gst-err-appId invalid-feedback`}>Please provide App Id.</div>
        </div>
        <div className="col-12">
          <label htmlFor="secretKey" className="form-label">Secret Key</label>
          <input
            type="text"
            className="form-control"
            id="secretKey"
            name='secretKey'
            value={data?.find(item => item.key === 'secretKey')?.value || ''}
            onChange={(e) => handleInputChange('secretKey', e.target.value)}
          />
          <div className={`gst-err-secretKey invalid-feedback`}>Please provide Secret Key.</div>
        </div>
        <div className="col-12">
          <label htmlFor="currency" className="form-label">Currency</label>
          <input
            type="text"
            className="form-control"
            id="currency"
            name='currency'
            value={data?.find(item => item.key === 'currency')?.value || ''}
            onChange={(e) => handleInputChange('currency', e.target.value)}
          />
          <div className={`gst-err-currency invalid-feedback`}>Please provide Currency.</div>
        </div>
        <div className="col-12">
          <label htmlFor="mode" className="form-label">Mode</label>
          <input
            type="mode"
            className="form-control"
            id="mode"
            name='mode'
            value={data?.find(item => item.key === 'mode')?.value || ''}
            onChange={(e) => handleInputChange('mode', e.target.value)}
          />
          <div className={`gst-err-mode invalid-feedback`}>Please provide Mode.</div>
        </div>
        <div className="col-12">
          <label htmlFor="returnUrl" className="form-label">Return Url</label>
          <input
            type="text"
            className="form-control"
            id="returnUrl"
            name='returnUrl'
            value={data?.find(item => item.key === 'returnUrl')?.value || ''}
            onChange={(e) => handleInputChange('returnUrl', e.target.value)}
          />
          <div className={`gst-err-returnUrl invalid-feedback`}>Please provide Return Url.</div>
        </div>
        <div className="col-12">
          <label htmlFor="notifyUrl" className="form-label">Notify Url</label>
          <input
            type="text"
            className="form-control"
            id="notifyUrl"
            name='notifyUrl'
            value={data?.find(item => item.key === 'notifyUrl')?.value || ''}
            onChange={(e) => handleInputChange('notifyUrl', e.target.value)}
          />
          <div className={`gst-err-notifyUrl invalid-feedback`}>Please provide Notify Url.</div>
        </div>
        <div className="col-12">
          <label htmlFor="PRODUrl" className="form-label">PROD Url</label>
          <input
            type="text"
            className="form-control"
            id="PRODUrl"
            name='PRODUrl'
            value={data?.find(item => item.key === 'PRODUrl')?.value || ''}
            onChange={(e) => handleInputChange('PRODUrl', e.target.value)}
          />
          <div className={`gst-err-PRODUrl invalid-feedback`}>Please provide PROD Url.</div>
        </div>
        <div className="col-12">
          <label htmlFor="TestUrl" className="form-label">Test Url</label>
          <input
            type="text"
            className="form-control"
            id="TestUrl"
            name='TestUrl'
            value={data?.find(item => item.key === 'TestUrl')?.value || ''}
            onChange={(e) => handleInputChange('TestUrl', e.target.value)}
          />
          <div className={`gst-err-TestUrl invalid-feedback`}>Please provide Test Url.</div>
        </div>
        <div className="col-12">
          <label htmlFor="paymentlanding" className="form-label">Payment Landing Url</label>
          <input
            type="text"
            className="form-control"
            id="paymentlanding"
            name='paymentlanding'
            value={data?.find(item => item.key === 'paymentlanding')?.value || ''}
            onChange={(e) => handleInputChange('paymentlanding', e.target.value)}
          />
          <div className={`gst-err-paymentlanding invalid-feedback`}>Please provide Payment Landing Url.</div>
        </div>
        <div className="text-center">
          <button type="Update" id="gstupdate" className="btn btn-primary">Update</button>
          <button type="Reset" className="btn btn-secondary">Reset</button>
        </div>
      </form>
    </div>
  );
}

export default Cashfree;